import React from 'react';
import { Box, makeStyles, TextField, Typography } from 'housecall-ui';

import { SelectedServiceHeader } from '../components/SelectedServiceHeader';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

const TEXTAREA_MAX_LENGTH = 2000;

export interface Props {
  descriptionMaxLength?: number;
}

const useStyles = makeStyles(() => ({
  charCounter: {
    marginLeft: 'auto',
  },
}));

export const DescriptionStep = ({ descriptionMaxLength = TEXTAREA_MAX_LENGTH }: Props) => {
  const { charCounter } = useStyles();
  const { state, dispatch, actions } = useOnlineBookingReducer();

  return (
    <>
      <SelectedServiceHeader />
      <Typography gutterBottom variant="h5">
        Describe how can we help
      </Typography>
      <Box my={2}>
        <TextField
          value={state.description}
          multiline
          placeholder="Write a short description and include specific details needed for the appointment."
          data-testid="online-booking-description"
          helperText={`${state.description.length}/${descriptionMaxLength}`}
          FormHelperTextProps={{
            className: charCounter,
          }}
          error={state.description.length >= descriptionMaxLength}
          inputProps={{
            maxLength: descriptionMaxLength,
          }}
          rows={8}
          fullWidth
          onChange={(event) => dispatch(actions.updateDescription(event.target.value))}
        />
      </Box>
    </>
  );
};
